<template>
  <div class="text-body-2">
    <div
      v-if="
        Object.keys(postgres).length > 1 &&
        typeof this.$store.getters.getSelectedData[
          Enums.DATA_SOURCE.POSTGRES
        ] !== 'undefined'
      "
    >
    <div v-if="this.postgres.statefips === '36'">
      <p class="pa-3 mt-1 font-weight-bold" style="border-bottom: 2px solid var(--celadon-blue);">Visit <a href="https://newyork.redistrictingandyou.org" target="_blank">Redistricting &amp; You: NYS</a> to see how this district compares with proposed redistricting plans.</p>
    </div>
          <ApportionmentHistory :statefips="this.postgres.statefips"/>
      <TablesCongress />
      <SideMenuTabs />
      <OnePOneVCongress
        v-show="
          this.activeTab === Enums.SIDE_TABS.ONE_PERSON ||
          this.$store.getters.getDialogOpen
        "
      />
      <DemographicsCongress
        v-show="
          this.activeTab === Enums.SIDE_TABS.DEMOGRAPHICS ||
          this.$store.getters.getDialogOpen
        "
      />
      <!-- <PopChange /> -->

      <!-- Current population section -->
      <!-- <v-app-bar color="#c0d7e4" dense height="30px" flat>
          <span class="text-uppercase" style="color: #1d3557; font-weight: 500"
            >Current population (</span
          ><a
            v-bind:href="
              'https://data.census.gov/cedsci/table?g=5001600US' +
              postgres.geoid +
              '&y=2019&d=ACS%201-Year%20Estimates%20Detailed%20Tables&tid=ACSDT1Y2019.B01003'
            "
            target="_blank"
            >2019 estimate</a
          ><span class="text-uppercase" style="color: #1d3557; font-weight: 500"
            >)</span
          >
        </v-app-bar>

        <p v-if="postgres.pop2019" class="mt-1">
          Estimated district population:
          <strong>{{ postgres.pop2019.toLocaleString() }} people</strong>.
          <br />
          Average district size in {{ postgres.statename }}:
          <strong
            >{{ Math.round(postgres.stateavg).toLocaleString() }} people</strong
          >.
        </p> -->
    </div>

    <hr />
  </div>
</template>
<script>
import { Enums } from "../../../data/Config/Config";
import SideMenuTabs from "../../Menus/SideMenu/SideMenuTabs";
import OnePOneVCongress from "../SelectedDistricts/Congress/OnePOneVCongress";
import DemographicsCongress from "../SelectedDistricts/Congress/DemographicsCongress";
import TablesCongress from "../SelectedDistricts/Congress/TablesCongress";
// import PopChange from "../SelectedDistricts/Congress/PopChange";
import ApportionmentHistory from "../ApportionmentHistory";
export default {
  name: "SelectedCongressDistrict",
  components: {
    SideMenuTabs,
    OnePOneVCongress,
    DemographicsCongress,
    TablesCongress,
    ApportionmentHistory,
    // PopChange,
  },
  computed: {
    propub: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.PROPUB] || {}
      );
    },
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
    activeTab: function () {
      return this.$store.getters.getSideTab;
    },
  },
  data: function () {
    return {
      Enums: Enums,
    };
  },
  watch: {},
  methods: {},
};
</script>
<style scoped>
.centertextblock {
  text-align: center;
  display: block;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.selected-district-data-item {
  padding: 10px;
}

.districtpanel-subhead {
  margin-top: 10px;
  margin-bottom: 0px !important;
  font-size: 1.1rem !important;
  font-weight: 400;
  letter-spacing: 0.0125em !important;
  font-style: italic;
}
.v-divider {
  margin-top: 10px;
}

.table-wrap-scoped,
td {
  word-wrap: initial;
}

/*LOCATION REPORT REPRESENTATIVE INFO*/
.representative {
  margin-top: 5px;
  margin-bottom: 25px;
}

.representative-name {
  font-size: 18px;
  color: #404040;
  margin-bottom: 5px;
}

.representative-photo {
  max-width: 100px;
  vertical-align: text-top;
}

ul.representative-info {
  color: #333333;
  margin-bottom: 6px;
}

ul.representative-info li {
  margin-bottom: 3px;
}

ul.representative-info li a {
  display: inline-block;
  /*margin-left:4px;*/
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
}

.representative-info-source {
  padding-left: 5px;
  display: inline-block;
}

.info-label {
  float: left;
  clear: both;
  margin-right: 8px;
}

.info-value {
  overflow: hidden;
}
</style>